(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function initProduct(sec) {
    if (sec.__skp) return;
    sec.__skp = true;
    var dataEl = sec.querySelector('[data-sk-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    var form = sec.querySelector('form[data-sk-atc]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var atc = sec.querySelector('[data-sk-main-atc]');
    var buyNow = sec.querySelector('[data-sk-buynow]');
    var stickyAtc = sec.querySelector('[data-sk-sticky-atc]');
    var now = sec.querySelector('[data-sk-price-now]');
    var was = sec.querySelector('[data-sk-price-was]');
    var off = sec.querySelector('[data-sk-price-off]');
    var badge = sec.querySelector('[data-sk-gal-badge]');
    var stickyPrice = sec.querySelector('[data-sk-sticky-price]');
    var track = sec.querySelector('[data-sk-track]');
    var thumbs = qsa('[data-sk-thumb]', sec);
    var addLabel = atc ? (atc.getAttribute('data-label') || 'Add to cart') : 'Add to cart';
    var soldLabel = atc ? (atc.getAttribute('data-sold') || 'Sold out') : 'Sold out';

    function selectedOptions() {
      return qsa('fieldset[data-sk-opt]', sec).map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) {
          if (v.options[k] !== opts[k]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function setButtons(available, label) {
      [atc, stickyAtc].forEach(function (b) {
        if (!b) return;
        b.disabled = !available;
        b.textContent = label;
      });
      if (buyNow) buyNow.disabled = !available;
    }
    function apply(v) {
      if (!v) { setButtons(false, 'Unavailable'); return; }
      if (idInput) idInput.value = v.id;
      if (now) now.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (was) { was.hidden = !v.compare; was.textContent = v.compare || ''; }
      if (off) { off.hidden = !(v.off > 0); off.textContent = v.off > 0 ? v.off + '% OFF' : ''; }
      if (badge) { badge.hidden = !(v.off > 0); badge.textContent = v.off > 0 ? v.off + '% OFF' : ''; }
      setButtons(v.available, v.available ? addLabel : soldLabel);
      if (v.media && track) {
        var slide = track.querySelector('[data-media-id="' + v.media + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    sec.addEventListener('change', function (e) {
      var fs = e.target.closest ? e.target.closest('fieldset[data-sk-opt]') : null;
      if (!fs) return;
      var lab = fs.querySelector('[data-sk-opt-value]');
      if (lab) lab.textContent = e.target.value;
      apply(findVariant(selectedOptions()));
    });

    /* quantity */
    var qty = sec.querySelector('[data-sk-qty]');
    sec.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest || !qty) return;
      var minus = t.closest('[data-sk-qty-minus]');
      var plus = t.closest('[data-sk-qty-plus]');
      if (minus) { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); }
      if (plus) { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); }
    });

    /* gallery thumbs */
    if (track) {
      thumbs.forEach(function (th, i) {
        th.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          thumbs.forEach(function (th, k) { th.classList.toggle('is-active', k === i); });
          ticking = false;
        });
      }, { passive: true });
    }

    /* zoom */
    sec.addEventListener('click', function (e) {
      var s = e.target.closest ? e.target.closest('[data-zoom]') : null;
      if (!s) return;
      var box = document.createElement('div');
      box.className = 'sk-lightbox';
      var img = document.createElement('img');
      img.src = s.getAttribute('data-zoom');
      img.alt = '';
      box.appendChild(img);
      function close() {
        if (box.parentNode) box.parentNode.removeChild(box);
        document.removeEventListener('keydown', onKey);
      }
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      box.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
      document.body.appendChild(box);
    });

    /* buy now */
    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        if (buyNow.disabled) return;
        buyNow.disabled = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form), credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyNow.disabled = false; });
      });
    }

    /* sticky add to cart bar */
    var bar = sec.querySelector('[data-sk-sticky]');
    var anchor = sec.querySelector('[data-sk-buy-anchor]');
    if (stickyAtc && atc) {
      stickyAtc.addEventListener('click', function () { atc.click(); });
    }
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(anchor);
    }
  }

  function initRecs(el) {
    if (el.__sk) return;
    el.__sk = true;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var d = new DOMParser().parseFromString(html, 'text/html');
        var inner = d.querySelector('[data-sk-recs-inner]');
        var mine = el.querySelector('[data-sk-recs-inner]');
        if (inner && mine && inner.querySelector('.sk-card')) { mine.innerHTML = inner.innerHTML; }
      })
      .catch(function () {});
  }

  function initAll() {
    qsa('[data-sk-product]').forEach(initProduct);
    qsa('[data-sk-recs]').forEach(initRecs);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
